import { onlyDigits } from './phone';

const DEFAULT_SUFFIX = 's.whatsapp.net';
const DIRECT_JID_SUFFIXES = new Set(['s.whatsapp.net', 'c.us']);
const OPAQUE_SUFFIXES = new Set(['lid']);

/**
 * Normaliza identificadores WhatsApp preservando JID/LID canônicos.
 * Aceita números, JIDs e LIDs e evita degradar identificadores opacos para dígitos.
 */
export function normalizeWhatsappJid(value) {
  if (value === undefined || value === null) return '';
  const trimmed = String(value).trim();
  if (!trimmed) return '';

  const withoutPrefix = trimmed.replace(/^whatsapp:/i, '');
  const [rawUsername, rawDomain = ''] = withoutPrefix.split('@', 2);
  const username = String(rawUsername || '').trim();
  const domain = String(rawDomain || '').trim().toLowerCase().replace(/^@+/, '');

  if (domain) {
    if (!username) return '';
    if (DIRECT_JID_SUFFIXES.has(domain)) {
      return `${username}@${domain}`;
    }
    if (OPAQUE_SUFFIXES.has(domain)) {
      return `${username}@${domain}`;
    }
    return '';
  }

  const digits = onlyDigits(username);
  if (!digits) return '';
  return `${digits}@${DEFAULT_SUFFIX}`;
}

export function normalizeWhatsappIdentifier(value) {
  return normalizeWhatsappJid(value);
}
